import { inject, Injectable } from '@angular/core';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { FeedbackPopoverTarget } from '../types/feedback-popover-state';

@Injectable()
export class CVFeedbackPopoverService {
  private store = inject(TaskWorkspaceStore);

  openList() {
    this.setPanel('list');
  }

  openDialog() {
    this.setPanel('upsert');
  }

  openView() {
    this.setPanel('view');
  }

  closePopover() {
    this.store('feedbackPopover')('target').set(undefined);
  }

  private setPanel(target: FeedbackPopoverTarget) {
    this.store('feedbackPopover')('target').set(target);
  }
}
